import React from "react";
import { observer } from "mobx-react";
import { Draggable } from "react-beautiful-dnd";

import TodoBody from "./TodoBody";

@observer
export default class Todo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { item, note, index } = this.props;

    return (
      <Draggable
        key={item.id}
        draggableId={String(item.id)}
        index={index}
        type={"TODO"}
      >
        {(provided, snapshot) => {
          const style = {
            // fontSize: snapshot.isDragging ? 18 : 14,
            ...provided.draggableProps.style,
            left: snapshot.isDragging ? "100 px !important" : null,
            top: snapshot.isDragging ? "100 px !important" : null
          };

          return (
            <React.Fragment>
              <div
                ref={provided.innerRef}
                {...provided.dragHandleProps}
                {...provided.draggableProps}
                style={style}
              >
                <TodoBody item={item} note={note} />
              </div>

              {provided.placeholder}
            </React.Fragment>
          );
        }}
      </Draggable>
    );
  }
}
